import React from 'react';

// Vendora88 brand mark: an interlocking two-tone "V" (blue = vendor, orange =
// customer) woven over-under at the base, set over a faint high-rise skyline
// (the gated communities served). Built from primitives so it scales with the
// `size` prop and needs no image asset.
//
// Geometry is authored at the 32px reference size and scaled uniformly.
const SKYLINE = [
    { w: 3, h: 8 },
    { w: 3.5, h: 13 },
    { w: 3, h: 10 },
    { w: 4, h: 14 },
    { w: 3, h: 9 },
];

export default function VendoraLogo({ size = 32 }) {
    const s = size / 32;
    const px = (n) => `${n * s}px`;

    const bar = (background, rotate, extra = {}) => (
        <span
            style={{
                position: 'absolute',
                left: px(9),
                top: px(-2),
                width: px(6),
                height: px(28),
                borderRadius: px(3),
                background,
                transformOrigin: '50% 82%',
                transform: `rotate(${rotate}deg)`,
                ...extra,
            }}
        />
    );

    return (
        <span
            style={{
                width: px(32),
                height: px(32),
                borderRadius: px(9),
                background: '#EAF0FB',
                position: 'relative',
                overflow: 'hidden',
                display: 'grid',
                placeItems: 'center',
                flex: 'none',
            }}
        >
            {/* skyline */}
            <span
                style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: px(15),
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'center',
                    gap: px(1.5),
                    opacity: 0.26,
                }}
            >
                {SKYLINE.map((b, i) => (
                    <span key={i} style={{ width: px(b.w), height: px(b.h), background: '#1E3A8A' }} />
                ))}
            </span>

            {/* woven V */}
            <span style={{ position: 'relative', display: 'block', width: px(24), height: px(22), marginTop: px(-2), zIndex: 2 }}>
                {bar('#E8770C', -28, { zIndex: 2 })}
                {bar('#2563EB', 28, { zIndex: 3 })}
                {/* clipped orange tip layered on top creates the over-under weave */}
                {bar('#E8770C', -28, { zIndex: 4, clipPath: `inset(80% 0 0 0 round ${px(3)})` })}
            </span>
        </span>
    );
}
